import React, { useContext } from 'react';
import { ConfigurationContext } from '../../../ContextProviders/ConfigurationProvider';
import Typography from '@material-ui/core/Typography';
import useConfigurationChanges from '../../../Hooks/useConfigurationChanges';
import Slider from '../../Slider';
import Grid from '@material-ui/core/Grid';
import { useTranslation } from 'react-i18next';
import GroupLabel from '../../GroupLabel';
import useItemRules from '../../../Rules/useItemRules';

const Dimensions = () => {
  const configuration = useContext(ConfigurationContext);
  const { t } = useTranslation();
  const { width, length, height } = useConfigurationChanges(configuration);

  const rules = useItemRules();

  if (!rules) {
    return null;
  }

  return (
    <>
      <Grid container spacing={0} justify="space-between">
        <Grid item>
          <GroupLabel id="width" gutterBottom>
            {t('dimensions.width')}
          </GroupLabel>
        </Grid>
        <Grid item>
          <Typography gutterBottom>{width} m</Typography>
        </Grid>
      </Grid>
      <Slider
        onChange={(evt, value) => configuration.setWidth(value)}
        defaultValue={rules.width.default}
        aria-labelledby="width"
        valueLabelDisplay="off"
        step={rules.width.step}
        min={rules.width.min}
        max={rules.width.max}
        value={width}
      />
      <Grid container spacing={0} justify="space-between">
        <Grid item>
          <GroupLabel id="length" gutterBottom>
            {t('dimensions.length')}
          </GroupLabel>
        </Grid>
        <Grid item>
          <Typography gutterBottom>{length} m</Typography>
        </Grid>
      </Grid>
      <Slider
        onChange={(evt, value) => configuration.setLength(value)}
        defaultValue={rules.length.default}
        aria-labelledby="length"
        valueLabelDisplay="off"
        step={rules.length.step}
        min={rules.length.min}
        max={rules.length.max}
        value={length}
      />

      <Grid container spacing={0} justify="space-between">
        <Grid item>
          <GroupLabel id="height" gutterBottom>
            {t('dimensions.height')}
          </GroupLabel>
        </Grid>
        <Grid item>
          <Typography gutterBottom>{height} m</Typography>
        </Grid>
      </Grid>
      <Slider
        onChange={(evt, value) => configuration.setHeight(value)}
        defaultValue={rules.height.default}
        aria-labelledby="height"
        valueLabelDisplay="off"
        step={null}
        marks={rules.height.values.map((v) => ({ value: v, label: v }))}
        max={rules.height.max}
        min={rules.height.min}
        value={height}
      />
    </>
  );
};

export default Dimensions;
